import HistorySectionCard from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistorySectionCard/HistorySectionCard';

export default HistorySectionCard;
